<template>
  <div class="tax-inquiry-statements-toggle">
    <div class="tax-inquiry-toggle-caption">Statements</div>
    <BinaryToggle
      id="taxInquiryStatementsToggle"
      aria-label="Statements: Print or Email"
      compact
      off-label="Print"
      on-label="Email"
      :value="togglePrintOrEmail"
      @input="res => setTogglePrintOrEmail({ res })" />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import BinaryToggle from '../../../common/base/BinaryToggle.vue';
import '../../../../assets/style.css';

// Print | Email for the statement buttons on Taxroll Search and Owner Search. It writes the same
// togglePrintOrEmail flag the old switch did, so everything that reads it is unchanged.
export default {
  name: 'StatementsToggle',
  components: { BinaryToggle },
  computed: {
    ...mapState({
      togglePrintOrEmail: (state) => state.tax.taxInquires.togglePrintOrEmail,
    }),
  },
  methods: {
    ...mapMutations('tax/taxInquires', ['setTogglePrintOrEmail']),
  },
};
</script>
